module.exports = __webpack_public_path__ + "static/img/item4.28a5f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item4.png
// module id = RdK+
// module chunks = 0